
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"34","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M30.4 8.5v-.2c0-.1 0-.1-.1-.2V8s-.1 0-.1-.1-.1-.1-.1-.1-.1-.1-.2-.1-.1-.1-.2-.1H3.1c-.1.1-.1.1-.2.1s-.1.1-.2.1c0 .1 0 .1-.1.2 0 0-.1 0-.1.1v.1c0 .1-.1.1-.1.2v16.8c0 .5.4 1 1 1h26c.5 0 1-.4 1-1V8.5c0 .1 0 .1 0 0zM26 9.6l-9.6 6-9.6-6H26zM4.4 24.1V10.4l11.5 7.2c.2.1.3.2.5.2s.4-.1.5-.2l11.5-7.2v13.7h-24z","fill":"#47AEA6"}}),_c('path',{attrs:{"d":"M33 27.5l-4.5-4.8c.9-1.2 1.4-2.5 1.4-4 0-3.6-3-6.6-6.6-6.6-3.6 0-6.6 3-6.6 6.6 0 3.6 3 6.6 6.6 6.6 1.3 0 2.4-.3 3.5-1l4.5 4.8c.2.2.6.3.8.3.2 0 .6-.1.8-.3.5-.3.5-1.1.1-1.6zm-13.9-8.8c0-2.3 2-4.3 4.3-4.3s4.3 2 4.3 4.3c0 1.3-.6 2.4-1.4 3.1-.7.7-1.7 1-2.8 1-2.4.1-4.4-1.8-4.4-4.1z","fill":"#F9A91E"}})])
          )
        }
      }
    